import { Dispatch, useCallback, useMemo } from "react";
import {
  HeldEmailQueueAction,
  HeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailBulkActionBar } from "./HeldEmailBulkActionBar";

interface Props {
  state: HeldEmailQueueState;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailQueueBulkActions({ state, dispatch }: Props) {
  const ids = useMemo(() => Array.from(state.selectedIds), [state.selectedIds]);
  const release = useCallback(
    () => dispatch({ type: "action", value: { type: "release", ids } }),
    [dispatch, ids]
  );
  const cancel = useCallback(
    () => dispatch({ type: "action", value: { type: "cancel", ids } }),
    [dispatch, ids]
  );
  return (
    <HeldEmailBulkActionBar
      onCancel={cancel}
      onRelease={release}
      selectedCount={ids.length}
    />
  );
}
